// Build media context string for AI to understand available content
// Now loads dynamically from content-data.json
import { IContentData } from '../../services/contentService';

export function getAllMediaContextFromData(data: IContentData): string {
  const sections: string[] = [];
  const catMap = new Map(data.categories.map(c => [c.id, c.name]));

  // Videos
  sections.push('[영상 콘텐츠]');
  const videosByCat = new Map<string, typeof data.videos>();
  data.videos.forEach(v => {
    const list = videosByCat.get(v.categoryId) || [];
    list.push(v);
    videosByCat.set(v.categoryId, list);
  });
  videosByCat.forEach((items, catId) => {
    const catName = catMap.get(catId) || catId;
    sections.push('  카테고리: ' + catName);
    items.forEach(v => {
      const type = v.yt ? 'YouTube' : '로컬 영상';
      sections.push('    - ' + v.title + ' (' + type + ')');
    });
  });

  // Images
  sections.push('\n[이미지 콘텐츠]');
  const imagesByCat = new Map<string, typeof data.images>();
  data.images.forEach(i => {
    const list = imagesByCat.get(i.categoryId) || [];
    list.push(i);
    imagesByCat.set(i.categoryId, list);
  });
  imagesByCat.forEach((items, catId) => {
    const catName = catMap.get(catId) || catId;
    sections.push('  카테고리: ' + catName);
    items.forEach(img => {
      sections.push('    - ' + img.title);
    });
  });

  // Audio
  sections.push('\n[오디오 콘텐츠]');
  const audiosByCat = new Map<string, typeof data.audios>();
  data.audios.forEach(a => {
    const list = audiosByCat.get(a.categoryId) || [];
    list.push(a);
    audiosByCat.set(a.categoryId, list);
  });
  audiosByCat.forEach((items, catId) => {
    const catName = catMap.get(catId) || catId;
    sections.push('  카테고리: ' + catName);
    items.forEach(aud => {
      sections.push('    - ' + aud.title);
    });
  });

  // YouTube feeds
  if (data.youtubeFeeds.length > 0) {
    sections.push('\n[YouTube 피드]');
    data.youtubeFeeds.forEach(y => {
      sections.push('  - ' + y.title);
    });
  }

  sections.push('\n[페이지 안내]');
  sections.push('  - /video: 영상 페이지 (유튜브 + 로컬 MP4 영상)');
  sections.push('  - /image: 이미지 페이지 (갤러리)');
  sections.push('  - /audio: 오디오 페이지 (음악/음성)');
  sections.push('  - /admin: 관리자 페이지 (콘텐츠 관리)');

  return sections.join('\n');
}

// Legacy compatibility - now uses dynamic data
export function getAllMediaContext(): string {
  return '콘텐츠 데이터를 로딩 중입니다. 잠시 후 다시 시도해주세요.';
}
